<template src="./Navigation.html"></template>
<style src="./Navigation.scss" lang="scss"></style>

<script>
	import Ad from '@/components/Ad/Ad';
	import Burger from '@/components/Burger/Burger';
	import Link from '@/components/Link/Link';

	/**
	 * The Navigation bar in header providing text links, burger menu and partner logo ads.
	 * @vue-prop {Object[]} [burgerMenu] The elements for the burger menu
	 * @vue-prop {Object[]} [navigation] The elements for the navigation
	 * @vue-prop {Object[]} [partnerLinks] The elements for the partner ads
	 */
	export default {
		name: 'HpNavigation',
		data () {
			return {
				brand: ''
			};
		},
		props: {
			burgerMenu: Array,
			navigation: Array,
			partnerLinks: Array
		},
		components: {
			'hp-ad': Ad,
			'hp-burger': Burger,
			'hp-link': Link
		},
		mounted () {
			this.brand = process.env.VUE_APP_BRAND; // for local purposes
		}
	};
</script>
